import { Vue, Component } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';
import LandscapeMode from '@/popupcomponents/landscapeMode/LandscapeMode.vue';
import APP_UTILITIES from '@/utilities/commonFunctions';

@Component({
  components: {
    'landscape-mode': LandscapeMode
  }
})
export default class FooterComponent extends Vue {
  public deviceIsMobile: boolean = false;

  openUrl() {
    window.open(APP_CONST.PRIVACY_POLICY, '_blank');
  }

  beforeMount() {
    this.deviceIsMobile = APP_UTILITIES.isDeviceMobile();
  }
}